/**
 * SB5-B.2 — TanStack Query keys for the contract-positions feature.
 */
import type { ListContractPositionsParams } from "./types.js";

export const contractPositionsKeys = {
  all: ["contract-positions"] as const,
  lists: () => [...contractPositionsKeys.all, "list"] as const,
  list: (params: ListContractPositionsParams) =>
    [...contractPositionsKeys.lists(), params] as const,
  details: () => [...contractPositionsKeys.all, "detail"] as const,
  detail: (id: string) => [...contractPositionsKeys.details(), id] as const,
  facets: () => [...contractPositionsKeys.all, "facets"] as const,
  projectsFacet: () => [...contractPositionsKeys.facets(), "projects"] as const,
  sitesFacet: (q: string) =>
    [...contractPositionsKeys.facets(), "sites", q] as const,
  assetsFacet: (q: string) =>
    [...contractPositionsKeys.facets(), "assets", q] as const,
  statesFacet: () => [...contractPositionsKeys.facets(), "states"] as const,
  // Add-modal helpers
  contractsByProject: (projectId: string | null) =>
    [...contractPositionsKeys.all, "contracts-by-project", projectId] as const,
  assetsBySite: (siteId: string | null) =>
    [...contractPositionsKeys.all, "assets-by-site", siteId] as const,
};
